import { render, staticRenderFns } from "./ScreeningResultsSemiCircle.vue?vue&type=template&id=6fe060fe&scoped=true&"
import script from "./ScreeningResultsSemiCircle.vue?vue&type=script&lang=js&"
export * from "./ScreeningResultsSemiCircle.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningResultsSemiCircle.vue?vue&type=style&index=0&id=6fe060fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe060fe",
  null
  
)

export default component.exports